import { Pipe, PipeTransform } from '@angular/core';
import { IHolidayDetailTourItinerary } from '../interfaces/iholiday-detail-tour-itinerary';
import { IHolidayDetailTourItineraryStop } from '../interfaces/iholiday-detail-tour-itinerary-stop';

@Pipe({
  name: 'tourStopMarkers'
})
export class TourStopMarkersPipe implements PipeTransform {

  getUniqueStops(stops: IHolidayDetailTourItineraryStop[]): IHolidayDetailTourItineraryStop[] {
    const retStops: IHolidayDetailTourItineraryStop[] = [];
    let lastStop: IHolidayDetailTourItineraryStop;
    stops.forEach(currentStop => {
      if (lastStop) {
        if (currentStop.lat !== lastStop.lat && currentStop.lng !== lastStop.lng) {
          retStops.push(currentStop);
        }
      } else {
        retStops.push(currentStop);
      }
      lastStop = currentStop;
    });
    return retStops;
  }

  transform(value: IHolidayDetailTourItinerary[]): {lat: number, lng: number, day: number, name: string, icon?: string, zIndex?: number}[] {
    const orderedStops = value.sort((a, b) => a.day - b.day).map(day => day.stops.sort((a, b) => a.order - b.order));
    return value ? this.getUniqueStops(orderedStops.flat()) : undefined;
  }

}
